import uniq from '@utils/uniq'

const MAX_FPS = 60
const FPS_INTERVAL = 1000 / MAX_FPS

const rafCallbacks = {}
let flatRafCallbacks = []

let lastDate = Date.now()
let dt = 0
let now = 0

function update (t) {
  window.requestAnimationFrame(update)

  now = Date.now()
  dt = now - lastDate

  if (dt > FPS_INTERVAL) {
    lastDate = now - (dt % FPS_INTERVAL)

    flatRafCallbacks.forEach((callback) => {
      callback(t)
    })
  }
}

update()

export default (component) => ({
  ...component,
  componentDidMount () {
    if (component.update) {
      this.rafId = uniq('int')
      rafCallbacks[this.rafId] = component.update.bind(this)
      flatRafCallbacks = Object.values(rafCallbacks)
    }

    this.componentWillUnmount = () => {
      this.stopUpdate()
      component.componentWillUnmount.call(this)
    }

    if (component.componentDidMount) component.componentDidMount.call(this)
  },

  stopUpdate () {
    delete rafCallbacks[this.rafId]
    flatRafCallbacks = Object.values(rafCallbacks)
  },
})
